import { render, staticRenderFns } from "./OrderErrorList.vue?vue&type=template&id=46e8f178&"
import script from "./OrderErrorList.vue?vue&type=script&lang=js&"
export * from "./OrderErrorList.vue?vue&type=script&lang=js&"
import style0 from "./OrderErrorList.vue?vue&type=style&index=0&id=46e8f178&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports